import { useDrawer } from '../inc-drawer/inc-drawer.hooks';
import { RelatedLocationsDrawerDataType } from './related-locations-drawer.component';

export const useRelatedLocationsDrawer = () =>
  useDrawer<RelatedLocationsDrawerDataType>();
